import styled from 'styled-components';
import { NeuCard, NeuInput, NeuTextarea, NeuButton } from '@neutron/react';

interface DropdownProps {
  showPopover: boolean;
}

export const AddQuestionCard = styled(NeuCard)`
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f6f6f6 !important;
  z-index: 10;
  width: 700px;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-inline-end: 0;
  margin-top: 0;
`;

export const CardHeader = styled(NeuCard)`
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  height: 56px;
  width: 100%;
  padding-top: calc(var(--card-spacing) / 2) !important;
  --background: white;
`;

export const ModalCardContent = styled(NeuCard)`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  width: 100%;
`;

export const QuestionTitleInput = styled(NeuInput)`
  position: relative;
  display: inline-block;
  flex: 1 0 60%;
  margin-left: 10px;
`;

export const CardContentContainer = styled.div`
  position: relative;
`;

export const RoundingTypeDropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  flex: 1 0 35%;
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.9375rem;
  margin-bottom: 0.9375rem;
`;

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #191919;
  flex-grow: 1;
`;

export const ModalInput = styled(NeuInput)`
  height: 42px;
`;

export const DropDownSearchContainer = styled.div<DropdownProps>`
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  width: 97%;
  min-height: 27px;
  max-height: 160px;
  z-index: 10;
  position: absolute;
  top: 42px;
  background: white !important;
  opacity: 1;
  overflow-y: scroll;
  display: ${props => (props.showPopover ? 'block' : 'none')};
`;

export const DropItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
  padding: 1px;
  opacity: 1;
`;

export const ModalFooter = styled(NeuCard)`
  bottom: 0;
  height: 69px !important;
`;

export const QuestionPartCard = styled(NeuCard)`
  align-items: flex-start;
  padding: 16px;
  gap: 16px;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
  margin-bottom: 10;
`;

export const QuestionPartCardHeader = styled(NeuCard)`
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  padding: 0.35rem !important;
`;

export const QuestionPartCardContents = styled(NeuCard)`
  width: 620px;
  align-items: flex-start;
  padding: 0.35rem !important;
`;

export const QuestionPartOptionInputContainer = styled.div`
  flex: 1 0 25%;
  color: #373737;
`;

export const QuestionPartType = styled.span`
  width: 136px;
  height: 26px;
  left: 16px;
  top: 16px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #4b4b4b;
`;

export const QuestionPartNavContainer = styled.div`
  color: #7c7c7c;
  align-items: center;
  display: flex;
  flex-direction: row;
  font-weight: 700;
  font-size: 0.875rem;
  cursor: pointer;
`;

export const QuestionPartBlueNavContainer = styled(QuestionPartNavContainer)`
  color: #2075ad;
`;

export const NavIconLabel = styled.div`
  margin-left: 5px;
`;

export const StyledLabel = styled.p`
  font-style: normal;
  font-size: 1rem;
  margin-bottom: 0;
`;

export const AddQuestionPartCard = styled(NeuCard)`
  display: flex;
  position: fixed;
  width: 22em;
  left: calc(50% - 319px / 2);
  top: calc(50% - 292px);
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  z-index: 10;
  padding-inline-start: 0;
`;
